export const SHOW = 'iframeDialog/SHOW'
export const HIDE = 'iframeDialog/HIDE'

const initState = {
    show: false,
    name: '' // component name
}

export default (state = initState, action) => {
    switch(action.type) {
        case SHOW:
            return {
                show: true,
                name: action.name
            }
        case HIDE:
            return {
                ...state,
                show: false,
                name: ''
            }
        default:
            return state
    }
}